import React from 'react';
import HelpSupportContent from '../../components/HelpSupportContent';

export default function HelpSupport() {
  return <HelpSupportContent roleLabel="Teacher" />;
}
